import React from "react";
import { useNavigate } from "react-router-dom";
import "./Header.css";
import logo from "../../assets/_logoname.png";
import useUserStore from "../../store/useUserStore";
import { logoutUser } from "../../services/auth";
import { MdLogout, MdAccountCircle } from "react-icons/md";

const Header = () => {
  const navigate = useNavigate();
  const { user, clearUser, getFullName } = useUserStore();

  const handleLogout = () => {
    // Clear user data from store
    clearUser();
    
    // Use the centralized logout function
    logoutUser();
    
    // Redirect to login page
    navigate("/login");
  };

  return (
    <header className="header">
      <div className="logo-container">
        <img src={logo} alt="Keejani Logo" className="logo" />
      </div>
      <div className="header-right">
        <div className="user-info">
          <MdAccountCircle className="user-icon" />
          <span className="user-name">{getFullName()}</span>
        </div>
        <button className="logout-btn" onClick={handleLogout}>
          <MdLogout className="logout-icon" />
          Logout
        </button>
      </div>
    </header>
  );
};

export default Header;
